import React, { Component, Fragment } from 'react';
import './AdvancedFilter.css';
import SubscriptionAdvancedFilter from '../../SubscriptionAdvancedFilter';

import { FilterIcon, CloseIcon } from '../../../../../common/icons';
import AirButton from '../../../../../common/components/AirButton';
import { inject, observer } from 'mobx-react';

@inject('translationsStore','subscriptionsStore','filterStore')
@observer
export default class AdvancedFilter extends Component {
  constructor(props) {
    super(props);

    this.advancedFilterRef = React.createRef();

    this.state = {
      isClosed: false,
      showDrawer: false
    };
  }

  componentDidMount = () => {
    this.AdvancedFilterInstance = this.advancedFilterRef.current.wrappedInstance;
  };

  render() {
    const { translationsStore, subscriptionsStore, filterStore } = this.props;
    let appliedFiltersLength = filterStore.appliedFiltersLengthFor('subscriptionFilter_');
    return (
      <div className="AdvancedFilter">
        {!!this.state.isClosed && (
          <div className="AdvancedFilterInner">
            <div>
              <FilterIcon style={{ color: 'white' }} />
            </div>
            <div>{translationsStore.translate('advancedfilter.filters')}</div>
          </div>
        )}
        {!this.state.isClosed && (
          <Fragment>
            {!appliedFiltersLength && (
              <AirButton
                onClick={() => {
                  this.AdvancedFilterInstance.show();
                }}
                className="openFilter"
                icon={<FilterIcon style={{ color: 'white' }} />}
                label={translationsStore.translate('advancedfilter.filters')}
              />
            )}
            {appliedFiltersLength > 0 && (
              <div className="filterActiveButton">
                <FilterIcon
                  style={{ color: 'white', width: '18px', height: '12px' }}
                  className="filterIcon"
                  onClick={() => {
                    this.AdvancedFilterInstance.show();
                  }}
                />
                <div>
                  {translationsStore.translate('advancedfilter.filters')} {appliedFiltersLength}
                </div>
                <CloseIcon
                  title="reset"
                  style={{ color: 'white', width: '14px', height: '14px' }}
                  className="closeIcon"
                  onClick={() => {
                    this.AdvancedFilterInstance.reset();
                    this.setState({ appliedFiltersLength: 0 });
                  }}
                />
              </div>
            )}
          </Fragment>
        )}
        <SubscriptionAdvancedFilter
          subscriptions={subscriptionsStore.filtered}
          visible={this.state.showDrawer}
          onApply={this.onApply}
          ref={this.advancedFilterRef}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App/SubscriptionManagerDashboard/SubHeader/AdvancedFilter/AdvancedFilter.js